module.exports = __webpack_public_path__ + "main/assets/public/player-controls/end-icon.04f4b61c98ff3f83.svg";